
import { HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { throwError as observableThrowError, Observable } from 'rxjs';
import { HttpInterceptor, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from '@angular/router';

import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/Observable';

import { AutenticacionService } from '../../seguridad/autenticacion.service';
import { Constante } from '../constante/constante';

@Injectable()
export class InterceptorService implements HttpInterceptor {

	constructor(private loginService: AutenticacionService,
		private router: Router) {
	}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		let peticionClonada: any;
		let httpOptions: any;

		let restPath = request.url.split(/[\s/]+/);

		if (restPath[restPath.length - 1] === Constante.PATH_LOGIN
			|| restPath[restPath.length - 1] === Constante.PATH_LOGOUT
			|| restPath[restPath.length - 1] === Constante.MESSAGE_FILE) {
			/* httpOptions = {
				observe: 'body',
				responseType: 'json',
				headers: request.headers
					.set('auth-resource', 'auth')
			} */
		} else if (restPath[restPath.length - 1] === Constante.PATH_DESCARGAR) {
			httpOptions = {
				observe: 'body',
			}
		} else if (restPath[restPath.length - 1] === Constante.PATH_SERVICIO) {
			httpOptions = {
				observe: 'body',
				responseType: 'text',
				headers: request.headers
				.set('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8')
				.set('Content-Type', 'application/json')
			}
		} else {
			httpOptions = {
				observe: 'body',
				responseType: 'json',
				headers: request.headers
					.set('auth-user', 'webUser')
					.set('auth-token', 'tokenUser')
					.set('auth-resource', restPath[restPath.length - 2])
			}
		}

		peticionClonada = request.clone(httpOptions)
		return next.handle(peticionClonada).do(event => {
			if (event instanceof HttpResponse) {
			}
		}).catch((exception) => {
			if (exception.status === 401 || exception.status === 403) {
				this.router.navigate(['/not-authorized']);
			} else if (exception.status === 408) {
				this.router.navigate(['/session-expired']);
			} else {
				return observableThrowError(exception);
			}
			return observableThrowError(exception);
		})
	}
}